// extracted by mini-css-extract-plugin
export default {"errPage":"styles_errPage__XPOcm","link":"styles_link__6tiw5","text":"styles_text__SZq5D"};